import * as React from "react";
import { useMemo } from "react";
import { MantineAccordion } from "components/bootstrap";
import { MarkdownPreview } from "components/common/MarkdownEditor";
import { Row } from "common/components/layout-styles";
import StepActionsButton from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
function StepLabel({ step, order, eventId = void 0 }) {
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between", style: { paddingRight: "0.5rem" } }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "auto" }, /* @__PURE__ */ React.createElement("span", null, order, "."), /* @__PURE__ */ React.createElement("span", null, step.title || `Step ${order}`)), /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "auto" }, /* @__PURE__ */ React.createElement(StepActionsButton, { step, eventId })));
}
function StepListView({ steps, eventId = void 0 }) {
  const items = useMemo(
    () => steps.map((step, index) => ({
      value: step.id,
      label: /* @__PURE__ */ React.createElement(StepLabel, { step, order: index + 1, eventId }),
      content: step.description ? /* @__PURE__ */ React.createElement(MarkdownPreview, { value: step.description, maxHeight: 300, noBackground: true, noBorder: true, noPadding: true, show: true }) : /* @__PURE__ */ React.createElement("i", null, "No description set for this step")
    })),
    [eventId, steps]
  );
  return /* @__PURE__ */ React.createElement(MantineAccordion, { variant: "separated", chevronPosition: "right", accordionItems: items, defaultValue: null });
}
export default StepListView;
